import { Component, OnInit } from '@angular/core';
import { IssuerAPIService } from '../services/issuer-api.service';
import { IssuerArchivedDocument } from '../Models/issuer-archived-document';
declare function responsiveVoiceSpeak(title, innerText): any;
declare function BrowseObligorsponsiveVoiceSpeak(placeholder, inputValue, keyCode, innerText, eventId, controlType, title, htmlFor, alt, key): any;
declare function voiceForLastObligor(targetid): any;
declare var $: any;
declare function FontSizeSettings(): any;

@Component({
  selector: 'app-archivedcurrentdocuments',
  templateUrl: './archivedcurrentdocuments.component.html',
  styleUrls: ['./archivedcurrentdocuments.component.css']
})
export class ArchivedcurrentdocumentsComponent implements OnInit {

  CountRows: number = 0;
  public documentArchivelist: IssuerArchivedDocument;
    //IssuerArchivedDocument

  //Get obligorId from local storage
  public obligorId = localStorage.getItem("OBLIGOR_ID");
  constructor(private IssuerAPIService: IssuerAPIService) { }
  onkeypress(event) {
    debugger;
    // Enable/Disable search button on the Obligor Name Search Box (3 or more letters).
    if (event.target.id == "inputSuccess5") {
      var btnSearch = <HTMLButtonElement>document.getElementById("btnSearch");
      if ((event.target.value.length + event.key.length) == 3 || (event.target.value.length + event.key.length) > 3) {
        btnSearch.disabled = false;
      }
      else {
        btnSearch.disabled = true;
      }
    }

    if (event.keyCode == 27) {
      //if (event.target.id == "tdAlerts" || event.target.id == "tdobligorDesc" || event.target.id == "tdwebcasts" || event.target.id == "tdOverview" || event.target.id == "tdHistory" || event.target.id == "tdQA") {
      document.getElementById("SkipMainContentfooter").focus();
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("SkipMainContentfooter").innerText, document.getElementById("SkipMainContentfooter").id, event.target.type, document.getElementById("SkipMainContentfooter").title, event.target.htmlFor, event.target.alt, event.key);
      //}
      return;
    }

    
    if (event.target.id == "tdHistory" && event.keyCode == 13) {
      //localStorage.clear();
      //localStorage.OBLIGOR_ID = obligorId;
      //localStorage.OBLIGOR_DESC = obligorDesc;
      //this.router.navigate(['/investor-browse-filing-types']);
    }
    else if (event.target.id == "tdQA" && event.keyCode == 13) {
      //localStorage.clear();
      //localStorage.OBLIGOR_ID = obligorId;
      //localStorage.OBLIGOR_DESC = obligorDesc;
      //this.router.navigate(['/ask-aquestion']);
    }
    else if (event.keyCode == 32) {
      if (event.target.id == "btnClear" || event.target.id == "btnSearch") {
        event.preventDefault();
        return;
      }
    }
  }
  onKeyUp(event: any) {
    debugger;
    $('#hdlastRow').val('0');
    //No Records found in table then voice and caption read No data available! 
    if (event.target.id == "noData" && event.keyCode == 9) {
      responsiveVoiceSpeak("", "No data available!" + ". Use escape key to exit the table and go to footer.");
      
    }
    if (event.target.id == "tblArchiveDocument" && event.keyCode == 9) {
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("tblArchiveDocument").innerText, "tblArchiveDocument", event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
      document.getElementById("tblArchiveDocument").focus();
      return;
    }

    if (event.target.id == "tblArchiveDocument" && event.keyCode == 9) {
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("tdtotalFiled").innerText, "tdtotalFiled", event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
      document.getElementById("tdtotalFiled").focus();
      return;
    }
   
    if ((event.target.id == "tdArchiveDocId" || event.target.id == "tdmostrecentId") && (event.keyCode == 9)) {
      event.preventDefault();
      return;
    }
    if (event.target.id == "lblarchivedcurrentdocuments" && event.keyCode == 13) {
      return;
    }

    if (event.target.id == "lblarchivedcurrentdocuments" && event.keyCode == 9) {
      //responsiveVoiceSpeak("", "This is Archived Current Documents page. Use tab to go to the next field.");
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("lblarchivedcurrentdocuments").innerText, "lblarchivedcurrentdocuments", event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
      document.getElementById("lblarchivedcurrentdocuments").focus();
      return;
    }

    //if (event.keyCode == 9 || event.keyCode == 13) {
    //  responsiveVoiceSpeak(event.target.title, event.target.innerText);
    //}
    if (event.keyCode != 17) {
      debugger;

      var child_cell = $(event.target).index();
      if (event.keyCode == 38) {
        this.UpArrowKey(event, child_cell);
          return;
        }
        else if (event.keyCode == 40) {
          debugger;
          this.DownArrowKey(event)
          return;
        }
        else if (event.keyCode == 39) {
          debugger;
          this.RightArrowKey(event, child_cell)

        }
        else if (event.keyCode == 37) {
          this.LeftArrowKey(event, child_cell);
        }
        else if (event.keyCode == 27) {
          //if (event.target.id == "tdAlerts" || event.target.id == "tdobligorDesc" || event.target.id == "tdwebcasts" || event.target.id == "tdOverview" || event.target.id == "tdHistory" || event.target.id == "tdQA") {
          document.getElementById("SkipMainContentfooter").focus();
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("SkipMainContentfooter").innerText, document.getElementById("SkipMainContentfooter").id, event.target.type, document.getElementById("SkipMainContentfooter").title, event.target.htmlFor, event.target.alt, event.key);
          //}
        }
        else if (event.keyCode == 16)//=============Shift + Tab Go
        {
          if (event.target.id == "tdtotalFiled" || event.target.id == "tdArchiveDocId" || event.target.id == "tdmostrecentId") {
            document.getElementById("lblarchivedcurrentdocuments").focus();
            BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("inputSuccess5").innerText, document.getElementById("inputSuccess5").id, event.target.type, document.getElementById("inputSuccess5").title, event.target.htmlFor, event.target.alt, event.key);
          }
        }
        else if (event.keyCode == 9) {
          if (event.target.id == "tdtotalFiled") {
            BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, event.target.innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
          }
          else {
            if (event.keyCode == 9) {
              BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, event.target.innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
            }
          }
        }
        else if (event.keyCode == 9) {
          if (event.target.id == "tdtotalFiled") {
            BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, event.target.innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
          }
          else {
            if (event.keyCode == 9) {
              BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, event.target.innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
            }
          }
        }

      }
    
  };
  UpArrowKey(event: any, child_cell: string) {
    var parent_cell = $(event.target).index();
    $(event.target).parent().prev().children("td").eq(parent_cell).focus();
    if (event.target.id == "tdtotalFiled") {
      var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[0].innerText;
      var title = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[0].title;
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, title, event.target.htmlFor, event.target.alt, event.key)
    }
    else if (event.target.id == "tdArchiveDocId") {
      var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[1].innerText;
      var title = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[1].title;
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, title, event.target.htmlFor, event.target.alt, event.key)
    }
    else if (event.target.id == "tdmostrecentId") {

      if ($(event.target).parent().prev().children("td").eq(child_cell).length == 0) {
        $('#hdlastRow').val('1');
      }
      else {
        $('#hdlastRow').val('0');
      }


      var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[2].innerText;
      var title = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[2].title;
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, title, event.target.htmlFor, event.target.alt, event.key)
    }
  }
  DownArrowKey(event: any) {
    debugger;
    var innerText, title, child_cell = $(event.target).index();
    $(event.target).parent().next().children("td").eq(child_cell).focus();
    if (event.target.id == "tdtotalFiled") {

      if ($(event.target).parent().next().children("td").eq(child_cell).length != 0) {

        if ($(event.target).parent().next().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }

        innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[0].innerText;
        title = $(event.target).parent().next().children("td").eq(child_cell).prevObject[0].title;
        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key)
        }
      }
    else if (event.target.id == "tdArchiveDocId") {
     
      if ($(event.target).parent().next().children("td").eq(child_cell).length != 0) {

        if ($(event.target).parent().next().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }
        innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[1].innerText;
        title = $(event.target).parent().next().children("td").eq(child_cell).prevObject[1].title;
        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key)
      }
    }
    else if (event.target.id == "tdmostrecentId") {

      if ($(event.target).parent().next().children("td").eq(child_cell).length != 0) {

        if ($(event.target).parent().next().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }

        innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[2].innerText;
        title = $(event.target).parent().next().children("td").eq(child_cell).prevObject[2].title;

        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, title, event.target.htmlFor, event.target.alt, event.key)
      }
    }
  }
  RightArrowKey(event: any, child_cell: string) {
    debugger;
    if (event.target.id == "tdtotalFiled") {
      var target = $(event.target).next();
      $(target).trigger('focus');
      if (target[0].id == "tdArchiveDocId") {

        if ($(event.target).parent().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }
        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, target[0].innerText, target[0].id, event.target.type, target[0].title, event.target.htmlFor, event.target.alt, event.key)
              
      }
    }

    if (event.target.id == "tdArchiveDocId") {
      debugger;
      var target = $(event.target).next();
      $(target).trigger('focus');
      if (target[0].id == "tdmostrecentId") {
        if ($(event.target).parent().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }

        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, target[0].innerText, target[0].id, event.target.type, target[0].title, event.target.htmlFor, event.target.alt, event.key)
               
      }
    }

   
    if (event.target.id == "tdmostrecentId") {
      var obligorDescIndex = 0;
      $(event.target).parent().next().children("td").eq(obligorDescIndex).focus();
      if (event.target.id == "tdmostrecentId") {
        if (typeof $(event.target).parent().next().children("td").eq(child_cell).prevObject[0] == "object") {
          var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[0].innerText;
          var title = $(event.target).parent().next().children("td").eq(child_cell).prevObject[0].title;

          if ($(event.target).parent().next().children("td").eq(child_cell).length == 0) {
            $('#hdlastRow').val('1');
          }
          else {
            $('#hdlastRow').val('0');
          }
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, "tdtotalFiled", event.target.type, "", event.target.htmlFor, event.target.alt, event.key)
        }
      }
    }
  }
  LeftArrowKey(event: any, child_cell: string) {
    debugger;
    if (event.target.id == "tdmostrecentId") {
      var target = $(event.target).prev();
      $(target).trigger('focus');
      if (target[0].id == "tdArchiveDocId") {
        if ($(event.target).parent().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }
        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, target[0].innerText, target[0].id, event.target.type, target[0].title, event.target.htmlFor, event.target.alt, event.key)
      }
    }
    if (event.target.id == "tdArchiveDocId") {
      var target = $(event.target).prev();
      $(target).trigger('focus');
      if (target[0].id == "tdtotalFiled") {

        if ($(event.target).parent().next().children("td").eq(child_cell).length == 0) {
          $('#hdlastRow').val('1');
        }
        else {
          $('#hdlastRow').val('0');
        }

        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, target[0].innerText, target[0].id, event.target.type, target[0].title, event.target.htmlFor, event.target.alt, event.key)
        
      }
    }

    if (event.target.id == "tdtotalFiled") {
      var obligorDescIndex = 2;
      $(event.target).parent().prev().children("td").eq(obligorDescIndex).focus();
      if (event.target.id == "tdtotalFiled") {
        if (typeof $(event.target).parent().prev().children("td").eq(child_cell).prevObject[2] == "object") {
          var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[2].innerText;
          var title = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[2].title;
          $('#hdlastRow').val('0');
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, "tdmostrecentId", event.target.type, title, event.target.htmlFor, event.target.alt, event.key)
        }
      }
    }
  }
  // Call Archive document api
  GetArchiveDocumentlistt(obligorId) {
    debugger;
    document.getElementById("overlay").style.display = "block";
    this.IssuerAPIService.GetIssuerBrowseArchivedAndCurrentDocuments(obligorId).subscribe(data => {
      document.getElementById("overlay").style.display = "none";
      this.documentArchivelist = data;
      this.CountRows = data["length"];
      this.MagnifieronDynamicChecking();
    });

    //return this.documentArchivelist;
  }
  // magnifier on off 
  MagnifieronDynamicChecking() {
    FontSizeSettings();
  }
  ngOnInit() {
  
    //=========Caption Hide Show=============//
    if ($('#hidglbVarOnOff').val() == "OFF") {
      $('#captionhideshow').hide();
      $('#btnOnOff').val('OFF')
    }
    else {
      $('#captionhideshow').show();
      $('#btnOnOff').val('ON')
    }
    responsiveVoiceSpeak("", "This is Archived Current Documents page. Use tab to go to the next field.");
    this.GetArchiveDocumentlistt(this.obligorId);
    this.MagnifieronDynamicChecking();
  }
  
  }


